import { render, staticRenderFns } from "./DownloadTablesView.vue?vue&type=template&id=3d46a752&"
import script from "./DownloadTablesView.vue?vue&type=script&lang=js&"
export * from "./DownloadTablesView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports